module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-videoSprite"
  }, [_c('video', {
    ref: "video",
    staticClass: "c-videoSprite__video",
    attrs: {
      "src": _vm.videoSrc,
      "webkit-playsinline": "",
      "playsinline": ""
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-ae27fde0"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/show/VideoSprite.vue
// module id = 206
// module chunks = 1